import styled from 'styled-components';
import { TableSortableHeaderCellMixin } from '../../mixins/components/TableSortableHeaderCellMixin';
import { StyledTableHeaderCell } from '../TableHeaderCell/TableHeaderCell.styles';
export var StyledTableSortableHeaderCell = /*#__PURE__*/styled(StyledTableHeaderCell).withConfig({
  displayName: "StyledTableSortableHeaderCell",
  componentId: "c11n-8-107-0__sc-mod41s-0"
})(["", ""], TableSortableHeaderCellMixin);